/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discreet_Shipping_SubInputs */

const en_discreet_shipping_sub = /** @type {(inputs: Discreet_Shipping_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reliable delivery`)
};

const th_discreet_shipping_sub = /** @type {(inputs: Discreet_Shipping_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดส่งเชื่อถือได้`)
};

const ja_discreet_shipping_sub = /** @type {(inputs: Discreet_Shipping_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確実にお届け`)
};

const fr_discreet_shipping_sub = /** @type {(inputs: Discreet_Shipping_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expédition fiable`)
};

const es_discreet_shipping_sub = /** @type {(inputs: Discreet_Shipping_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega fiable`)
};

const ru_discreet_shipping_sub = /** @type {(inputs: Discreet_Shipping_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Надёжная отправка`)
};

const zh_discreet_shipping_sub = /** @type {(inputs: Discreet_Shipping_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稳妥送达`)
};

const vi_discreet_shipping_sub = /** @type {(inputs: Discreet_Shipping_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao nhận đáng tin cậy`)
};

/**
* | output |
* | --- |
* | "Reliable delivery" |
*
* @param {Discreet_Shipping_SubInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const discreet_shipping_sub = /** @type {((inputs?: Discreet_Shipping_SubInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discreet_Shipping_SubInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_discreet_shipping_sub(inputs)
	if (locale === "ja") return ja_discreet_shipping_sub(inputs)
	if (locale === "fr") return fr_discreet_shipping_sub(inputs)
	if (locale === "es") return es_discreet_shipping_sub(inputs)
	if (locale === "ru") return ru_discreet_shipping_sub(inputs)
	if (locale === "zh") return zh_discreet_shipping_sub(inputs)
	if (locale === "vi") return vi_discreet_shipping_sub(inputs)
	return en_discreet_shipping_sub(inputs)
});